/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {checkRewardCode} from '../api'

 export const useQueryCheckRewardCode = createReactQueryHook('checkRewardCode', checkRewardCode)
